import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, Box, Stack, Typography} from 'views/components';

import {translate, Translate} from 'views/module';

const SubscribeUserDialog = (props) => {
  const {open, onClose, onSubmit, initialChannelValue, isLoading, channelType, regex, errorMessage = ''} = props;
  const [channelValue, setChannelValue] = React.useState(initialChannelValue);
  const [isValid, setIsValid] = React.useState(() => {
    if (regex && initialChannelValue) {
      return regex.test(initialChannelValue);
    } else {
      return false;
    }
  });
  const [helperText, setHelperText] = React.useState('');

  React.useEffect(() => {
    setChannelValue(initialChannelValue);
  }, [initialChannelValue, open]);

  const handleChange = (newValue) => {
    setChannelValue(newValue);
  };

  const isFormValid = React.useCallback(() => {
    if (regex) {
      if (!isValid) {
        return false;
      }
    }
    return channelValue?.trim();
  }, [channelValue]);

  React.useEffect(() => {
    if (regex && !isValid) {
      setHelperText(errorMessage);
    } else {
      setHelperText('');
    }
  }, [channelValue, errorMessage]);

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle onClose={onClose}>
        <Translate
          expression='client.ClientDetail.Relationships.Notification.Subscribe'
          substitute={{channelType: translate(`client.ClientDetail.Relationships.Notification.ChannelType.${channelType}`)}}
        />
      </DialogTitle>
      <DialogContent>
        <Box>
          <Stack spacing={2}>
            <Box>
              <Typography variant="h6"></Typography>
            </Box>
            <TextField
              label={<Translate expression={`client.ClientDetail.Relationships.Notification.ChannelType.${channelType}`} />}
              value={channelValue}
              onChange={(e) => handleChange(e)}
              fullWidth
              validation={{regex, update: setIsValid}}
              helperText={helperText}
            />
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Close' />
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={() => onSubmit(channelValue)}
          disabled={isLoading || !isFormValid()}
        >
          <Translate
            expression='client.ClientDetail.Relationships.Notification.Subscribe'
            substitute={{channelType: translate(`client.ClientDetail.Relationships.Notification.ChannelType.${channelType}`)}}
          />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

SubscribeUserDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialChannelValue: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  channelType: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  regex: PropTypes.instanceOf(RegExp),
};

export default SubscribeUserDialog;
